import { ReminderRulesTable } from "components";

const ReminderRules = () => {
    return (
        <ReminderRulesTable />
    );
}

export default ReminderRules;
